import Cookie from 'js-cookie';

const RemoveAllCookies = () => {
  const cookies = Object.keys(Cookie.get());
  cookies.forEach(cookieName => {
    Cookie.remove(cookieName);
  });
};

export default RemoveAllCookies;